import { render, staticRenderFns } from "./PaymentAccountEditTabInformation.vue?vue&type=template&id=154bdd12&"
import script from "./PaymentAccountEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./PaymentAccountEditTabInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports